import { LoadingChip } from '@app/components/base/LoadingChip';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { socialExportPublishMessages } from './social-export-publish-messages';

interface SocialExportUploadStatusChipProps {
  /** BFF upload status string (e.g. COMPLETED, SCHEDULED). */
  status: string | undefined;
}

/**
 * Small Chip for social upload status. Compares status as plain strings so it works for any DTO that uses the same enum values.
 */
export function SocialExportUploadStatusChip({ status }: SocialExportUploadStatusChipProps) {
  const { $t } = useIntl();

  if (!status) {
    return null;
  }

  if (status === 'COMPLETED') {
    return (
      <Chip size="small" color="success" label={$t(socialExportPublishMessages.chipPublished)} />
    );
  }

  if (status === 'SCHEDULED') {
    return <Chip size="small" color="info" label={$t(socialExportPublishMessages.chipScheduled)} />;
  }

  if (status === 'WAITING' || status === 'WAITING_CHILDREN' || status === 'IN_PROGRESS') {
    return <LoadingChip label={$t(socialExportPublishMessages.chipInProgress)} />;
  }

  if (status === 'FAILED') {
    return <Chip size="small" color="error" label={$t(socialExportPublishMessages.chipError)} />;
  }

  if (status === 'CANCELLED') {
    return (
      <Chip size="small" color="default" label={$t(socialExportPublishMessages.chipCancelled)} />
    );
  }

  return null;
}
